const i = (e = 0) => new Promise((t) => {
  const s = window.sessionStorage.getItem(`pageViews-${e}`);
  s ? parseInt(s, 10) < 3 ? window.sessionStorage.setItem(`pageViews-${e}`, parseInt(s, 10) + 1) : t(!0) : window.sessionStorage.setItem(`pageViews-${e}`, "2");
});
export {
  i as default
};
